import * as Yup from 'yup';

export const validationSchema = schemas => {
  return Yup.object().shape(schemas);
};

export const defaultValues = values => {
  return values;
};
